export const EXIT_COMPONENT_EDIT_EVENT = 'icms.exitComponentEdit';
